import {REGISTRY_SINGLETON} from '../../scenes/Registry';

/**
 * Перемещение (и маневр) отряда попадает в стор не в момент клика по ячейке, а
 * в колбэке анимации полета отряда — см. GameScene.handleMovementPhaseClick и
 * handleManeuverPhaseClick, UNIT_MOVEMENT_DURATION_MS = 400 мс на сегмент пути.
 * Пока отряд летит, клик уже совершен, а состояние в сторе еще доанимационное.
 *
 * Занятость целевой ячейки проверяет интерфейс (редьюсеры MOVE_UNIT и
 * ADD_PENDING_MOVEMENT_ACTION ее сознательно не проверяют), и проверяет он ее
 * по состоянию НА МОМЕНТ КЛИКА. Поэтому любое игровое действие, успевшее
 * изменить состояние за время полета, ломает базовый инвариант «в одной
 * ячейке не больше одного отряда»: отмена последнего перемещения возвращала
 * отряд на ячейку, которая в момент клика была свободна, и прилетевший следом
 * отряд вставал поверх него. На этот инвариант, в частности, опирается
 * точечная отмена двойным кликом (findMovementUndoConflict).
 *
 * Клики по канве анимацию добивают сами (GameScene.handleClick), а кнопки
 * футера и заголовка — обычные DOM-элементы, такой защиты у них нет. Списка
 * «опасных кнопок» здесь намеренно нет: опасна не кнопка, а изменение
 * состояния, поэтому анимация добивается перед ЛЮБЫМ игровым экшеном. Признак
 * тот же, по которому networkMiddleware отличает игровое действие матча от
 * локального экшена клиента, — отсутствие noServerSync: выделение отряда,
 * тосты, модалки и прочий локальный UI анимацию не обрывают.
 *
 * Добитая анимация сначала фиксирует перемещение в сторе (колбэк вызывается
 * синхронно), и только потом применяется сам экшен — порядок получается тот
 * же, в котором игрок нажимал.
 */
export const createUnitMovementAnimationMiddleware = ({getHexGridRenderer}) => () => (next) => (action) => {
  if (action && !action.noServerSync) {
    // Рекурсии нет: skipUnitMovementAnimation снимает флаг анимации ДО вызова
    // колбэка, и вложенные MOVE_UNIT/ADD_PENDING_MOVEMENT_ACTION из колбэка
    // выходят из него сразу
    getHexGridRenderer()?.skipUnitMovementAnimation?.();
  }

  return next(action);
};

const unitMovementAnimationMiddleware = createUnitMovementAnimationMiddleware({
  getHexGridRenderer: () => REGISTRY_SINGLETON.getHexGridRenderer(),
});

export default unitMovementAnimationMiddleware;
